module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_footer_hapista-f8d9a6ff93bdd6fe81b37cce26cebbc4.svg";